import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLInputElement> {
  static targets = ["clearButton", "input"]
  declare readonly clearButtonTarget: HTMLElement
  declare readonly inputTarget: HTMLInputElement

  clear(): void {
    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.focus()
  }

  hideOrFocusButton(e: FocusEvent): void {
    // Don't hide button if it's about to be focused. Note element needs be a real `button` or have
    // a `tabindex` attribute for this comparison to work.
    if (e.relatedTarget === this.clearButtonTarget) {
      this.clearButtonTarget.focus()
    } else {
      this.clearButtonTarget.hidden = true
    }
  }

  showButton(): void {
    this.clearButtonTarget.hidden = false
  }
}
